// extracted by mini-css-extract-plugin
module.exports = {"CvLoader":"custom-cv-load_CvLoader__1NI4x","CvNotFoundLink":"custom-cv-load_CvNotFoundLink__BsFMz"};